// Vixera brand logo — a sassy winged "cat-eye" mark + gradient wordmark.

export function VixenMark({ size = 24, className = "" }) {
  const h = (size * 26) / 46;
  return (
    <svg
      width={size}
      height={h}
      viewBox="0 0 46 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="vixgrad" x1="0" y1="0" x2="1" y2="1">
          <stop stopColor="#FF3D81" />
          <stop offset="1" stopColor="#FF7A45" />
        </linearGradient>
      </defs>
      {/* eye almond */}
      <path
        d="M3 13 C11 3, 26 3, 32 13 C26 22, 11 22, 3 13 Z"
        stroke="url(#vixgrad)"
        strokeWidth="2.2"
        fill="none"
        strokeLinejoin="round"
      />
      {/* winged flick */}
      <path
        d="M31 12 C36 9, 40 5.5, 45 2"
        stroke="url(#vixgrad)"
        strokeWidth="2.6"
        strokeLinecap="round"
        fill="none"
      />
      {/* iris */}
      <circle cx="17.5" cy="12.8" r="4.3" fill="url(#vixgrad)" />
    </svg>
  );
}

export function Logo({ className = "", markSize = 22, showMark = true }) {
  return (
    <span className={`inline-flex items-center gap-2 font-logo font-bold leading-none ${className}`}>
      {showMark && <VixenMark size={markSize} />}
      <span>
        Vix<span className="logo-grad">era</span>
      </span>
    </span>
  );
}

export default Logo;
